import { ConstantItems } from '@constants/shared'
import { UserItem } from '@app/users/UserItem';
import { EmailUserGroup } from '@models/bulkemailing/emailUserGroups';
import internal = require('events');

export class UsersRepo {
  static $inject = ["$http", "config"];

  constructor(private $http: angular.IHttpService, private config: ConstantItems) { }

  getUser(userId: number) {
    return this.$http.get(`${this.config.userUrl}/${userId}`);
  }

  getUsers() {
    return this.$http.get(this.config.userUrl).then(resp => resp.data as UserItem[]);
  }

  getUsersForRole(role: string) {
    return this.$http.get(`${this.config.userUrl}/${role}`);
  }

  getUserRoles(username: string) {
    return this.$http.get(`${this.config.userUrl}/roles/${username}`);
  }

  getUserStatus(username: string) {
    return this.$http.get(`${this.config.userUrl}/status/${username}`);
  }

  resendInvite(userId: number) {
    return this.$http.post(`${this.config.userUrl}/resendinvite/${userId}`, {});
  }

  saveUser(user: any) {
    return this.$http.post(`${this.config.userUrl}`, user)
      .then(resp => resp.data as UserItem);
  }

  saveUserDetails(user: any) {
    return this.$http.put(`${this.config.userUrl}/${user.id}/details`, user);
  }

  saveUserRoles(user: any) {
    if (user.id) {
      return this.$http.put(`${this.config.userUrl}/roles/${user.id}`, user);
    }
  }

  saveUserClients(user: any) {
    if (user.id) {
      return this.$http.put(`${this.config.userUrl}/clients/${user.id}`, user);
    }
  }

  getUserEmailGroups() {
    return this.$http.get(`${this.config.userUrl}/groups`)
      .then(resp => resp.data as EmailUserGroup[]);
  }

  getTermsAndConditions () {
    return this.$http.get(`${this.config.userUrl}/terms`);
  }

  hasUserAcceptedTermsConditions = () => {
    return this.$http.get(`${this.config.userUrl}/terms/accepted`);
  }

  acceptTermsConditions = () => {
    return this.$http.put(`${this.config.userUrl}/terms`,null);
  }

  getCurrentUserApprovalStatus() {
    return this.$http.get(`${this.config.userUrl}/current/approval-status`);
  }
}



// WEBPACK FOOTER //
// ./src/services/users.repo.ts